import { render, staticRenderFns } from "./regionConfig.vue?vue&type=template&id=a991e87e&scoped=true"
import script from "./regionConfig.vue?vue&type=script&lang=js"
export * from "./regionConfig.vue?vue&type=script&lang=js"
import style0 from "./regionConfig.vue?vue&type=style&index=0&id=a991e87e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991e87e",
  null
  
)

export default component.exports